import Tool from './Tool';
import { ConnectorEnd } from '../types';
import ConnectorArrowButton from './ConnectorArrowButton';

class ToolConnectorStartArrow extends Tool {
  static toolName = 'Connector start';

  static buttonComponent() {
    return ConnectorArrowButton(ConnectorEnd.CONNECTOR_START);
  }
}

export default ToolConnectorStartArrow;
